var _____WB$wombat$assign$function_____ = function(name) {return (self._wb_wombat && self._wb_wombat.local_init && self._wb_wombat.local_init(name)) || self[name]; };
if (!self.__WB_pmw) { self.__WB_pmw = function(obj) { this.__WB_source = obj; return this; } }
{
  let window = _____WB$wombat$assign$function_____("window");
  let self = _____WB$wombat$assign$function_____("self");
  let document = _____WB$wombat$assign$function_____("document");
  let location = _____WB$wombat$assign$function_____("location");
  let top = _____WB$wombat$assign$function_____("top");
  let parent = _____WB$wombat$assign$function_____("parent");
  let frames = _____WB$wombat$assign$function_____("frames");
  let opener = _____WB$wombat$assign$function_____("opener");

document.addEventListener("DOMContentLoaded", function() {
    if (typeof reviewSliderConfig !== 'undefined') {
        const reviewSlider = document.querySelector(`#slider-${reviewSliderConfig.blockId}`);
        let reviewCurrentSlide = 0;
        const reviewTotalSlides = reviewSlider ? reviewSlider.children.length : 0;
        const reviewBullets = document.querySelectorAll(`.mini-container-pagination-${reviewSliderConfig.blockId} .mini-container-pagination-bullet`);

        // Function to auto-slide
        function reviewAutoSlide() {
            reviewCurrentSlide = (reviewCurrentSlide + 1) % reviewTotalSlides;
            reviewSlider.scrollLeft = reviewSlider.clientWidth * reviewCurrentSlide;
            updateReviewBullets();
        }

        // Function to update active bullet
        function updateReviewBullets() {
            reviewBullets.forEach((bullet, index) => {
                if (index === reviewCurrentSlide) {
                    bullet.classList.add('active');
                } else {
                    bullet.classList.remove('active');
                }
            });
        }

        setInterval(reviewAutoSlide, reviewSliderConfig.interval);
        // Initialize the first bullet as active
        updateReviewBullets();
    }
});

}
/*
     FILE ARCHIVED ON 17:17:08 Dec 17, 2024 AND RETRIEVED FROM THE
     INTERNET ARCHIVE ON 02:28:23 Feb 05, 2025.
     JAVASCRIPT APPENDED BY WAYBACK MACHINE, COPYRIGHT INTERNET ARCHIVE.

     ALL OTHER CONTENT MAY ALSO BE PROTECTED BY COPYRIGHT (17 U.S.C.
     SECTION 108(a)(3)).
*/
/*
playback timings (ms):
  captures_list: 0.611
  exclusion.robots: 0.034
  exclusion.robots.policy: 0.021
  esindex: 0.01
  cdx.remote: 7.345
  LoadShardBlock: 149.653 (3)
  PetaboxLoader3.datanode: 156.363 (4)
  load_resource: 210.215
  PetaboxLoader3.resolve: 156.069
*/